module.exports = __webpack_public_path__ + "static/img/triangle.6b44c806.svg";